<template>
  <div>
    <v-btn @click="onClick" flat small>
      <v-icon>{{ icon }}</v-icon>
      文字コード
    </v-btn>
    <v-slide-y-transition>
      <v-select
        v-model="selectedEncode"
        v-if="visible"
        :items="encodeItems"
        label="文字コード"
        hint="Excelでファイルを開く場合、Shift-JISを選択して下さい。"
        persistent-hint
      />
    </v-slide-y-transition>
  </div>
</template>

<script>
import Encode from '@/constants/encode'

export default {
  name: 'SimulationResultEncodeSelector',
  props: {
    value: {
      type: String,
      default: Encode.SHIFT_JIS,
    },
  },
  data() {
    return {
      visible: false,
      encodeItems: [Encode.SHIFT_JIS, Encode.UTF_8],
    }
  },
  computed: {
    selectedEncode: {
      get() {
        return this.value
      },
      set(encode) {
        this.$emit('input', encode)
      },
    },
    icon() {
      return this.visible ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
    },
  },
  methods: {
    onClick() {
      this.visible = !this.visible
    },
  },
}
</script>

<style scoped></style>
